import { isInJestMode } from '@dxb-web-ui-framework/common/domain/Environment/EnvironmentService';
import { genericMapToHandlers } from '@dxb-web-ui-framework/mocks/msw/utils/genericMapToHandlers';
import { genericJourneyResolverMapping } from '@dxb-web-ui-framework/mocks/msw/types';
import { ecommbx } from '../../index';

const appBootstrappingMap: genericJourneyResolverMapping[] = [
  {
    url: /\/public-web/,
    response: () => null,
    method: 'head',
    responseHeaders: { Environment: 'local' },
  },
  {
    url: /\/secure-web/,
    response: () => null,
    method: 'head',
    responseHeaders: { Environment: 'local' },
  },
  {
    url: /\/ecommbx\/secure-web\/discovery.service.json/,
    response: () => (isInJestMode() ? ecommbx.testsDiscoveryServiceData : ecommbx.localDiscoveryServiceData),
    method: 'get',
  },
  {
    url: /\/ecommbx\/public-web\/discovery.service.json/,
    response: () => (isInJestMode() ? ecommbx.testsDiscoveryServiceData : ecommbx.localDiscoveryServiceData),
    method: 'get',
  },
];

const appBootstrappingHandlers = appBootstrappingMap.map(genericMapToHandlers);

export { appBootstrappingHandlers };
